import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Quote, ArrowLeft, ArrowRight } from 'lucide-react';
const testimonials = [{
  quote: 'Their strategic guidance was instrumental in navigating the complex regulatory landscape of Southeast Asia. We reduced our time-to-market by 4 months.',
  author: 'Sarah Jenkins',
  role: 'VP of Operations',
  company: 'TechFlow Systems'
}, {
  quote: 'A partner that truly understands the nuances of international trade. Their compliance audit saved us from potential fines and streamlined our customs process.',
  author: 'Michael Chen',
  role: 'Director of Logistics',
  company: 'Global Pharma Corp'
}, {
  quote: "888 Sourcing Limited's risk management framework helped us weather the supply chain disruptions of the past year with minimal impact to our bottom line.",
  author: 'James Wilson',
  role: 'CEO',
  company: 'Wilson Manufacturing'
}, {
  quote: 'The depth of their local network in emerging markets is unmatched. They connected us with reliable partners we never would have found on our own.',
  author: 'Elena Kova',
  role: 'Head of Expansion',
  company: 'Retail Group Intl'
}];
export function TestimonialsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  useEffect(() => {
    if (isPaused) return;
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [isPaused]);
  const nextSlide = () => {
    setCurrentIndex(prev => (prev + 1) % testimonials.length);
  };
  const prevSlide = () => {
    setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  };
  return <section className="py-24 bg-[#1a2d4a] relative overflow-hidden" data-id="element-568">
      {/* Background Pattern */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none" data-id="element-569">
        <div className="absolute right-0 top-0 w-96 h-96 bg-[#d4a853] rounded-full blur-[100px]" data-id="element-570" />
        <div className="absolute left-0 bottom-0 w-64 h-64 bg-white rounded-full blur-[80px]" data-id="element-571" />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-572">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center" data-id="element-573">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-574">
            <div className="flex items-center gap-3 mb-6" data-id="element-575">
              <div className="h-px w-12 bg-[#d4a853]" data-id="element-576" />
              <span className="text-[#d4a853] font-medium tracking-[0.2em] uppercase text-sm" data-id="element-577">
                Client Feedback
              </span>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-8" data-id="element-578">
              Trusted by Industry Leaders
            </h2>
            <p className="text-gray-400 text-lg mb-8 max-w-md" data-id="element-579">
              We build long-term partnerships based on trust, transparency, and
              tangible results. Here's what our clients have to say.
            </p>

            <div className="flex gap-4" data-id="element-580">
              <button onClick={prevSlide} className="w-12 h-12 rounded-full border border-white/20 flex items-center justify-center text-white hover:bg-[#d4a853] hover:text-[#0a1628] hover:border-[#d4a853] transition-all cursor-pointer" aria-label="Previous testimonial" data-id="element-581">
                <ArrowLeft size={20} data-id="element-582" />
              </button>
              <button onClick={nextSlide} className="w-12 h-12 rounded-full border border-white/20 flex items-center justify-center text-white hover:bg-[#d4a853] hover:text-[#0a1628] hover:border-[#d4a853] transition-all cursor-pointer" aria-label="Next testimonial" data-id="element-583">
                <ArrowRight size={20} data-id="element-584" />
              </button>
            </div>
          </motion.div>

          <div className="relative h-[400px] flex items-center" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} data-id="element-585">
            <AnimatePresence mode="wait" data-id="element-586">
              <motion.div key={currentIndex} initial={{
              opacity: 0,
              x: 50
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -50
            }} transition={{
              duration: 0.5
            }} className="bg-[#0a1628] p-8 md:p-12 border-l-4 border-[#d4a853] relative w-full shadow-xl" data-id="element-587">
                <Quote className="absolute top-6 right-6 text-[#1a2d4a] w-16 h-16" data-id="element-588" />
                <p className="text-xl md:text-2xl text-gray-300 italic mb-8 relative z-10 leading-relaxed" data-id="element-589">
                  "{testimonials[currentIndex].quote}"
                </p>
                <div data-id="element-590">
                  <div className="text-white font-bold text-lg" data-id="element-591">
                    {testimonials[currentIndex].author}
                  </div>
                  <div className="text-[#d4a853] text-sm uppercase tracking-wider" data-id="element-592">
                    {testimonials[currentIndex].role},{' '}
                    {testimonials[currentIndex].company}
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>

            {/* Dots */}
            <div className="absolute -bottom-8 left-0 flex gap-2" data-id="element-593">
              {testimonials.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`h-1.5 rounded-full transition-all duration-300 ${index === currentIndex ? 'w-8 bg-[#d4a853]' : 'w-2 bg-white/20 hover:bg-white/40'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-594" />)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}